export default "__VITE_ASSET__BxRZgMjG__"